var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEssayHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41177 4.86938C5.25266 4.86938 0.159376 4.86938 0 4.86938V46.8106H15.5588C16.1004 45.8642 16.5657 45.051 17.1072 44.1047C16.5657 43.1583 16.1004 42.3451 15.5588 41.3988C15.2725 40.368 5.69778 5.89897 5.41177 4.86938Z",
    fill: "#65E4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9177 39.7451L15.5588 41.3987V46.8104H31.1177C31.1177 46.1557 31.1177 42.0577 31.1177 41.3987L21.9177 39.7451Z",
    fill: "#57C6FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41187 0.810547V41.3988H20.2942L21.6472 18.3988L20.2942 0.810547C19.8744 0.810547 5.83146 0.810547 5.41187 0.810547Z",
    fill: "#E4F0FD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1765 0.810547C34.7567 0.810547 20.7138 0.810547 20.2942 0.810547V41.3988H35.1765C35.1765 40.2546 35.1765 1.95468 35.1765 0.810547Z",
    fill: "#CADBFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0587 18.3987C26.1124 18.3987 25.2992 18.3987 24.3529 18.3987C24.3529 17.2425 24.3529 16.249 24.3529 15.0927C25.4985 14.0448 27.0587 12.7592 27.0587 11.634C27.0587 10.888 26.4519 10.2811 25.7058 10.2811C24.9598 10.2811 24.3529 10.888 24.3529 11.634C23.4065 11.634 22.5933 11.634 21.647 11.634C21.647 9.39607 23.4676 7.5752 25.7058 7.5752C27.9437 7.5752 29.7646 9.39589 29.7646 11.634C29.7646 13.5589 28.4754 14.9696 27.0587 16.2881V18.3987Z",
    fill: "#E33657"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0589 23.8106C26.1126 23.8106 25.2994 23.8106 24.353 23.8106V21.1047H27.0589V23.8106Z",
    fill: "#E33657"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8235 23.8106H20.2941L20.9705 22.4577L20.2941 21.1047H10.8235V23.8106Z",
    fill: "#CADBFD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8235 15.6929V18.3988H20.2941L20.9705 17.0458L20.2941 15.6929H10.8235Z",
    fill: "#CADBFD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9411 12.9871H10.8235C10.8235 12.0408 10.8235 11.2276 10.8235 10.2812H18.9411V12.9871Z",
    fill: "#CADBFD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9411 7.57527H10.8235C10.8235 6.62893 10.8235 5.81572 10.8235 4.86938H18.9411V7.57527Z",
    fill: "#CADBFD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46 31.9283C46 30.982 46 30.1687 46 29.2224H43.2941L42.5725 30.5754L43.2941 31.9283L44.647 32.6499L46 31.9283Z",
    fill: "#FD5959"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2941 31.9282L42.5725 33.2812L43.2941 34.6341H46C46 33.6878 46 32.8746 46 31.9282H43.2941Z",
    fill: "#E33657"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2353 31.9283L40.4529 30.5754L39.2353 29.2224H17.855L17.1072 31.1391L17.855 31.9283L28.5451 33.0557L39.2353 31.9283Z",
    fill: "#FDDD41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6471 23.8106C21.6471 22.8643 21.6471 22.0511 21.6471 21.1047H20.2942V23.8106H21.6471Z",
    fill: "#ABC7F0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6471 15.6929C21.174 15.6929 20.7674 15.6929 20.2942 15.6929V18.3988H21.6471C21.6471 17.4524 21.6471 16.6392 21.6471 15.6929Z",
    fill: "#ABC7F0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.855 31.9282L17.1072 32.6949L17.855 34.6341H39.2353L40.4529 33.2812L39.2353 31.9282H17.855Z",
    fill: "#FCBC40"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.855 29.2224C16.5653 30.0823 15.0859 31.0685 13.7961 31.9283L16.2803 32.6499L17.855 31.9283C17.855 30.982 17.855 30.1687 17.855 29.2224Z",
    fill: "#DA804A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7961 31.9282C15.0859 32.7881 16.5653 33.7743 17.855 34.6341C17.855 33.6878 17.855 32.8746 17.855 31.9282C16.5037 31.9282 15.1475 31.9282 13.7961 31.9282Z",
    fill: "#B35F49"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2942 31.9283V29.2224H39.2354V31.9283L41.2648 33.0557L43.2942 31.9283Z",
    fill: "#4E5F7F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2354 31.9282H43.2942V34.6341H39.2354V31.9282Z",
    fill: "#3D4665"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEssayHelp);
export default __webpack_public_path__ + "static/media/essayHelp.fb8ae1a4aa2568102c2c8baf41135d03.svg";
export { ForwardRef as ReactComponent };